import React from "react";

const Stat = ({ label, value }) => (
  <div data-testid={`netprice-snapshot-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="text-[11px] uppercase tracking-[0.14em] mb-1" style={{ color: "#9ca3af" }}>
      {label}
    </div>
    <div className="text-base sm:text-lg" style={{ color: "#111928", fontWeight: 500 }}>
      {value || "Not reported"}
    </div>
  </div>
);

const fmtPct = (v) => (typeof v === "number" ? `${Math.round(v * 100)}%` : null);
const fmtMoney = (v) => (typeof v === "number" ? `$${v.toLocaleString()}` : null);

export default function SchoolSnapshot({ school }) {
  return (
    <div
      className="rounded-xl p-5 sm:p-6 grid grid-cols-2 sm:grid-cols-3 gap-y-5 gap-x-6"
      style={{ background: "#ffffff", border: "1px solid #e5e7eb" }}
      data-testid="netprice-snapshot">
      <Stat label="Graduation rate" value={fmtPct(school.graduationRate)} />
      <Stat label="Median earnings 10yr" value={fmtMoney(school.medianEarnings10yr)} />
      <Stat label="Admission rate" value={fmtPct(school.admissionRate)} />
      <Stat label="In state tuition" value={fmtMoney(school.tuitionInState)} />
      <Stat label="Out of state tuition" value={fmtMoney(school.tuitionOutOfState)} />
      <Stat label="Cost of attendance" value={fmtMoney(school.costOfAttendance)} />
    </div>
  );
}
